<template>
  <div v-if="show">

    <loading :loading="loading"></loading>

    <div>
      <weex-text class="input_label">Enter Request</weex-text>
      <input
          class="multi-line-input"
          :value="requestBody"
          @input="requestBody = $event.target.value"
      />

      <wxc-button
          text="Send Request"
          class="horizontal_center margin-top-20"
          type="blue"
          @wxcButtonClicked="sendRequest"
      ></wxc-button>

    </div>

    <error-alert-item
      :logout-on-network-error="false"
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
      ></error-alert-item>

    <update-password-dialog
        :show="showUpdatePasswordDialog"
        :user-id="userId"
        @dismissClicked="onPasswordUpdateDismiss"
        @onPasswordUpdated="onPasswordUpdated"
    ></update-password-dialog>

    <div v-if="false">

      <username-password-view
        :show="true"
        @onLoginClicked="onLoginWithUsernamePasswordClicked($event.username, $event.password)"
        ref="usernamePasswordViewRef"
        ></username-password-view>

      <div
        v-if="loginWithPhoneNumberAllowed"
        class="margin-top-10">
        <weex-text class="text-align-center font-weight-bold text-color-gray">-OR-</weex-text>
        <weex-text class="margin-top-10 text-align-center">
          <span
            class="item-base-link"
            @click="onContinueWithPhoneNumberClicked">Continue with Phone Number
          </span>
        </weex-text>
      </div>
    </div>

    <div v-if="false">
      <div class="input_container">
        <weex-text class="input_label">{{getEnterMobileNumberHeading}}</weex-text>
        <div class="item-phone-number-input-container margin-top-5">
          <phone-code-item></phone-code-item>
          <input
            :disabled="phoneNumberInputDisabled"
            class="item-phone-number-input"
            :value="phoneNumber"
            maxlength="10"
            @input="phoneNumber=$event.target.value"
            :placeholder="getEnterMobileNumberPlaceholder"
            type="number"/>

          <wxc-button
            v-if="phoneNumberInputDisabled"
            text="EDIT"
            :btn-style="{width: '100px',backgroundColor: 'gray'}"
            :text-style="{'text-align': 'center'}"
            @wxcButtonClicked="onPhoneNumberEditClicked"
            ></wxc-button>
        </div>
      </div>

      <div
        v-if="showPhoneNumberVerifyButtonsDiv"
        class="margin-top-30">
        <wxc-button
          text="Send OTP"
          class="horizontal_center"
          type="blue"
          @wxcButtonClicked="onSendSMSOtpClicked"
          ></wxc-button>
      </div>

      <s-m-s-o-t-p-view
        ref="smsOTPView"
        :show="showSMSOTPView"
        @onLoginClicked="onLoginWithSMSOTPClicked($event.otp)"
        @onCallAndVerifyClicked="onCallAndVerifyClicked"
        @onSendOTPClicked="onSendSMSOtpClicked"
        ></s-m-s-o-t-p-view>

      <call-and-verify-view
        :show="showCallAndVerifyView"
        :call-and-verify-message="callAndVerifyMessage"
        :otp="generatedOTP"
        @onLoginClicked="onLoginWithCallAndVerifyClicked"
        @onVerifyWithSMSOTPClicked="onSendSMSOtpClicked"
        ></call-and-verify-view>

      <div
        v-if="loginWithUsernameAllowed"
        class="margin-top-10">
        <weex-text class="text-align-center font-weight-bold text-color-gray">-OR-</weex-text>
        <weex-text class="margin-top-10 text-align-center">
          <span
            class="item-base-link"
            @click="onContinueWithUsernamePassword">
            Continue with Username/Password
          </span>
        </weex-text>
      </div>
    </div>
  </div>
</template>

<script>
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import Loading from "./Loading";
  import ErrorAlertItem from "./ErrorAlertItem";
  import AlertService from "../core/alert/AlertService";
  import { MessageConstants } from "../../utils/MessageConstantUtil";
  import EzUtils from "../../utils/EzUtils";
  import AuthenticationService, { LoginMode } from "../core/authentication/AuthenticationService";
  import { environment } from "../../environments/environment";
  import CallAndVerifyView from "./CallAndVerifyView";
  import SMSOTPView from "./SMSOTPView";
  import UsernamePasswordView from "./UsernamePasswordView";
  import { Constants } from '../Constants';
  import CoBrandingDataHolder from '../../data/model/CoBrandingDataHolder';
  import UpdatePasswordDialog from "../dialogs/UpdatePasswordDialog";
  import PhoneCodeItem from "@/components/layout/PhoneCodeItem";
  import DataSource from "../../data/DataSource";

  export default {
    name: "LoginItem",
    components: {
      WxcButton,
      Loading,
      ErrorAlertItem,
      CallAndVerifyView,
      SMSOTPView,
      UsernamePasswordView,
      UpdatePasswordDialog,
      PhoneCodeItem
    },
    data: () => ({
      requestBody: "",
      showLoginWithPhoneNumberItem: false,
      showUsernamePasswordItem: false,
      loginWithPhoneNumberAllowed: false,
      loginWithUsernameAllowed: false,
      showCallAndVerifyView: false,
      showPhoneNumberVerifyButtonsDiv: true,
      showSMSOTPView: false,
      phoneNumber: "",
      phoneNumberInputDisabled: false,
      smsOTPId: -1,
      generatedOTP: "",
      generatedOTPId: -1,
      loading: false,
      errorAlertEvent: false,
      networkError: {},
      showUpdatePasswordDialog: false,
      userId: -1
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      }
    },

    methods: {
      showLoginView(
        loginWithUsernameAllowed,
        loginWithPhoneNumberAllowed,
        phoneNumber
      ) {
        this.loginWithUsernameAllowed = loginWithUsernameAllowed;
        this.loginWithPhoneNumberAllowed = loginWithPhoneNumberAllowed;
        this.resetFieldsAndItems();
        if(!this.isEzCredJourneyTypeAssisted()){
          this.phoneNumber = phoneNumber;
        }
        if (this.loginWithPhoneNumberAllowed) {
          this.showLoginWithPhoneNumberItem = true;
        } else if (this.loginWithUsernameAllowed) {
          this.showUsernamePasswordItem = true;
        }
      },

      sendRequest() {
        this.loading = true;
        DataSource.camspayInstanach(this.requestBody)
        .then(res => {
          this.loading = false;
        })
      },

      showToast(message) {
        AlertService.showToast(message);
      },

      showError(error) {
        this.loading = false;
        this.networkError = error;
        this.errorAlertEvent = true;
      },

      resetFieldsAndItems() {
        this.resetPhoneNumberLayout();
        this.showLoginWithPhoneNumberItem = false;
        this.showUsernamePasswordItem = false;
        this.phoneNumber = "";
        this.loading = false;
        this.errorAlertEvent = false;
        this.networkError = {};
      },

      resetPhoneNumberLayout() {
        this.smsOTPId = -1;
        this.generatedOTP = "";
        this.generatedOTPId = -1;
        this.phoneNumberInputDisabled = false;
        this.showPhoneNumberVerifyButtonsDiv = true;
        this.showSMSOTPView = false;
        this.showCallAndVerifyView = false;
      },

      onPhoneNumberEditClicked() {
        this.resetPhoneNumberLayout();
      },

      onVerifyWithSMSOTPClicked() {
        this.resetPhoneNumberLayout();
      },

      onSendSMSOtpClicked() {
        if (EzUtils.validatePhoneNumber(this.phoneNumber)) {
          this.loading = true;
          AuthenticationService.sendOtp(this.phoneNumber)
            .then(smsOTPRes => {
              this.loading = false;
              if (smsOTPRes.errorOccurred) {
                this.showError(smsOTPRes.data);
              } else {
                this.showPhoneNumberVerifyButtonsDiv = false;
                this.smsOTPId = smsOTPRes.data.id;
                this.showCallAndVerifyView = false;
                this.showSMSOTPView = true;
                this.phoneNumberInputDisabled = true;
                this.showToast(MessageConstants.OTP_SENT_MESSAGE);
                this.$refs.smsOTPView.showSMSOTPView();
              }
            })
        } else {
          this.showToast(MessageConstants.INVALID_PHONE_NUMBER_MESSAGE)
        }
      },

      onCallAndVerifyClicked() {
        if (EzUtils.validatePhoneNumber(this.phoneNumber)) {
          this.loading = true;
          AuthenticationService.generateOTP(this.phoneNumber)
            .then(generatedOTPRes => {
              this.loading = false;
              if (generatedOTPRes.errorOccurred) {
                this.showError(generatedOTPRes.data);
              } else {
                const generatedOTPData = generatedOTPRes.data ? generatedOTPRes.data : {};
                this.showPhoneNumberVerifyButtonsDiv = false;
                this.generatedOTP = generatedOTPData.otp ? generatedOTPData.otp.toString() : "";
                this.generatedOTPId = generatedOTPRes.data.id;
                this.showSMSOTPView = false;
                this.showCallAndVerifyView = true;
                this.phoneNumberInputDisabled = true;
              }
            })
        } else {
          this.showToast(MessageConstants.INVALID_PHONE_NUMBER_MESSAGE)
        }
      },

      onContinueWithPhoneNumberClicked() {
        this.resetFieldsAndItems();
        this.showLoginWithPhoneNumberItem = true;
      },

      onContinueWithUsernamePassword() {
        this.resetFieldsAndItems();
        this.showUsernamePasswordItem = true;
      },

      onLoginWithUsernamePasswordClicked(username, password) {
        this.loading = true;
        AuthenticationService.login(
            {username: username, password: password, loginWithCredentials: true}
        )
        .then(authenticateResponse => {

          this.loading = false;
          if (authenticateResponse.errorOccurred) {
            this.showError(authenticateResponse.data);
          } else {
            this.onLoginSuccess(authenticateResponse.data);
          }
        })
      },

      onLoginWithSMSOTPClicked(otp) {
        this.loginWithPhoneNumber(otp, this.smsOTPId, LoginMode.OTP_SMS);
      },

      onLoginWithCallAndVerifyClicked() {
        this.loginWithPhoneNumber(this.generatedOTP, this.generatedOTPId, LoginMode.OUTBOUND_CALL);
      },

      loginWithPhoneNumber(otp, otpId, mode) {
        this.loading = true;
        AuthenticationService.login({
          username: this.phoneNumber,
          password: otp,
          dataId: otpId,
          mode: mode,
          rememberMe: false,
          loginWithCredentials: false
        })
        .then(loginRes => {
          this.loading = false;
          if (loginRes.errorOccurred) {
            this.showError(loginRes.data);
            this.showLoginWithPhoneNumberItem = true;
          } else {
           this.onLoginSuccess(loginRes.data);
          }
        })
      },

      onLoginSuccess(response) {
        if (response && response.shouldRenewPassword) {
          this.userId = response.user ? response.user.userId : -1;
          this.showUpdatePasswordDialog = true;
        } else {
          this.showUpdatePasswordDialog = false;
          this.$emit("onLoggedIn");
        }
      },

      isEzCredJourneyTypeAssisted(){
        return Constants.EZCRED_JOURNEY_TYPE_ASSISTED === CoBrandingDataHolder.getEzCredJourneyType();
      },

      onPasswordUpdated() {
        this.showUpdatePasswordDialog = false;
        this.$refs.usernamePasswordViewRef.clearPassword();
        this.showToast("Password updated successfully. Please login again to continue.");
        AuthenticationService.logoutAndClearLocalStorageData();
      },

      onPasswordUpdateDismiss() {
        this.showUpdatePasswordDialog = false;
        AuthenticationService.logoutAndClearLocalStorageData();
      }
    },

    computed: {
      callAndVerifyMessage() {
        return `Please call <b>${environment.callAndVerifyMobile}</b> from <b>${this.phoneNumber}</b> and enter the below OTP.`;
      },

      getEnterMobileNumberHeading(){
        return this.isEzCredJourneyTypeAssisted()
        ? "Please enter your registered mobile with EzCred" : "Please enter your 10 digit mobile number"
      },

      getEnterMobileNumberPlaceholder(){
        return this.isEzCredJourneyTypeAssisted()
        ? "Agent Mobile Number" : "Customer Mobile Number"
      },
    }
  }
</script>


<style
  scoped
  src="../../assets/style/base.css"></style>
